/**
 * useRecentlyViewed — hook do localStorage z ostatnio oglądanymi pozycjami katalogu.
 *
 * API:
 *   const { recent, addRecent, clearRecent } = useRecentlyViewed();
 *
 * Trzyma do 5 ostatnich pozycji jako pełne snapshoty (id, slug, type, title, image, subtitle).
 * Dzięki temu sekcja „Kontynuuj przeglądanie" działa nawet bez ponownego fetcha z API.
 */
import { useCallback, useEffect, useState } from 'react';

const KEY = 'apisai_recently_viewed_v1';
const MAX = 5;

function readStorage() {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeStorage(items) {
  try {
    window.localStorage.setItem(KEY, JSON.stringify(items.slice(0, MAX)));
  } catch {
    /* noop — storage full / disabled */
  }
}

export default function useRecentlyViewed() {
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    setRecent(readStorage());
  }, []);

  const addRecent = useCallback((item) => {
    if (!item || !(item.id || item.slug)) return;
    const snapshot = {
      id: item.id || item.slug,
      slug: item.slug,
      type: item.type || 'hodowla',
      title: item.title || '',
      image: item.image || null,
      subtitle: item.subtitle || '',
      url: item.url || null,
      added_at: Date.now(),
    };
    setRecent(prev => {
      const filtered = prev.filter(p => p.id !== snapshot.id && p.slug !== snapshot.slug);
      const next = [snapshot, ...filtered].slice(0, MAX);
      writeStorage(next);
      return next;
    });
  }, []);

  const clearRecent = useCallback(() => {
    writeStorage([]);
    setRecent([]);
  }, []);

  return { recent, addRecent, clearRecent };
}
